import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

import { Filters } from '../Filters';
import { TrendingAuctions } from '../TrendingAuctions';

const Relative = styled.div`
  position: relative;
  isolation: isolate;
`;

const Layout = styled(Horizontal)`
  gap: 0;
`;
const Main = styled(Vertical).attrs({ gap: 4 })`
  max-width: 100%;
  padding-right: var(--double-unit);
`;

export const MarketHomePage = ({ sport }: { sport: Sport }) => {
  return (
    <Relative>
      <Filters sport={sport} />
      <Layout>
        <Main>
          <TrendingAuctions sport={sport} />
        </Main>
      </Layout>
    </Relative>
  );
};
